import React from 'react';
import { useTranslation } from 'react-i18next';
import { btn } from './ui';

// The create button of the workspace's document lists (owner 2026-11-02, "Standardize New Document Button Across All
// Modules": one design, top right beside Export, no floating + on these lists). It is the white toolbar button Sales had
// until 7b6d8605 moved it to the Fab: the `btn` style, the plus icon, the words. Every list says "New document", so the
// button reads the same wherever it stands; `title` says what THIS list creates. `label` is for a list that does not
// hold documents (Products & accounts). The caller keeps its own conditions: never for a read-only seat, never without
// the merchant — the server refuses those seats, and each refusal pages the admins (middleware.ts).
export default function NewDocBtn({ onClick, title, label }: { onClick: () => void; title: string; label?: string }) {
  const { t } = useTranslation();
  return (
    <button type="button" style={btn} onClick={onClick} title={title}>
      <i className="ti ti-plus" aria-hidden /> {label || t('aw_doc_new')}
    </button>
  );
}
